const $window = jQuery(window);

export default function (player) {
  // check for option
  const $container = jQuery(player?.elements?.container);
  if (!$container.length) {
    return;
  }
  const $parents = $container.parents();
  const $wrapper = $container.closest(".presto-player__wrapper");
  let videoHeight = $container.outerHeight();

  const resizeObserver = new ResizeObserver(() => {
    if (!$container.hasClass("presto-sticky")) {
      videoHeight = $container.outerHeight();
    }
  });

  resizeObserver.observe($container.get(0));

  $window.on("scroll", () => {
    if (!player?.config?.sticky_scroll) {
      return;
    }

    var windowScrollTop = $window.scrollTop();
    var videoBottom = videoHeight + $wrapper.offset().top;

    if (windowScrollTop > videoBottom && player.playing) {
      $wrapper.height(videoHeight);
      $container.addClass("presto-sticky");
      $parents.addClass("presto-sticky-parent");
    } else {
      $wrapper.height("auto");
      $container.removeClass("presto-sticky");
      $parents.removeClass("presto-sticky-parent");
    }
  });
}
